module.exports = __webpack_public_path__ + "static/img/85040D_3_C_20230615_LC.ecb90ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/85040D_3_C_20230615_LC.png
// module id = dCql
// module chunks = 0